<template>
  <div>
    <el-dialog
      append-to-body
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
      title="完成"
      top="60px"
      :visible.sync="dialogShow"
      width="50%"
      :modal-append-to-body="false"
    >
      <template slot="title">
        <div class="avue-crud__dialog__header">
          <span class="el-dialog__title">
            完成
          </span>
          <i
            class="el-icon-full-screen"
            style="margin-right:20px;position:relative;top:-1px"
            @click="dialogFull = !dialogFull"
          ></i>
        </div>
        <el-divider></el-divider>
      </template>
      <div :style="'max-height:' + dialogBodyHight + 'px;overflow:scroll;'">
        <avue-form
          :option="option"
          v-model="form"
          ref="form"
          v-if="dialogShow"
          @submit="formSubmit"
          @error="formError"
        >
          <template slot="remark">
            <div>
              <el-input
                type="textarea"
                :rows="3"
                maxlength="500"
                show-word-limit
                placeholder="请输入内容"
                v-model="form.remark"
              >
              </el-input>
              <remarkModel :remark.sync="form.remark" ref="remarkModel"></remarkModel>
            </div>
          </template>
          <template slot="attachList">
            <div>
              <vupload
                :fileList.sync="form.attachList"
                :limit="5"
                message="提示：请上传jpg,png或者MP4格式文件！"
                messageType="pre"
                :types="[
                  'audio/mp4',
                  'video/mp4',
                  'image/png',
                  'image/jpeg',
                  'image/x-png',
                  'image/pjpeg',
                ]"
                :max="20 * 1024 * 1024"
                typesFlag="multi"
              ></vupload>
            </div>
          </template>
          <!-- <template slot="menuForm">
            <el-button @click="closeDialog" ><span class="el-icon-close"></span> 取消</el-button>
          </template> -->
        </avue-form>
      </div>
      <template slot="footer">
        <el-button @click="formSubmit1" size="small" type="primary"
          ><span class="el-icon-check"></span> 保存</el-button
        >
        <el-button @click="handleClose" size="small" style="margin-right:15px"
          ><span class="el-icon-close"></span> 取消</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { advisoryEndOption } from './action-option.js';
import { getRemarkList, finish } from '@/api/crmedical/order/order-list/order-list';
import remarkModel from '../components/remark-model';
import vupload from '@/views/components/v-upload';
import { fieldDetail } from '@/api/v4ward/ordersetting/setting/selfForm';
export default {
  components: {
    remarkModel,
    vupload,
  },
  data() {
    return {
      dialogFull: false,
      form: {
        orderId: '',
        attachList: [],
      },
      data: {},
      cheackedPeople: [],
      userList: [],
      dialogShow: false,
      option: advisoryEndOption,
      orderId: '',
      submitFlag: true, //防重提交
      descriptionFlag: false,
      uploadFileFlag: false,
      moduleType: '',
    };
  },
  created() {},
  watch: {
    'form.orderServiceType': function(val) {
      this.option.column[1].display = val == 7;
      this.$refs.form.updateOption(this.option);
    },
  },
  mounted() {
    this.dialogFull = false;
    let bodyHight = document.body.clientHeight;
    this.dialogBodyHight = bodyHight - 300;
  },
  methods: {
    //获取字段填写修饰
    async getFieldDetail(projectId, moduleType, actionType) {
      console.log('执行了');
      let obj = {
        projectId: projectId,
        moduleType: moduleType,
        actionType: actionType,
      };
      await fieldDetail(obj).then((res) => {
        let description, uploadFile;
        res.data.forEach((item) => {
          if (item.fieldCode == 'description') {
            description = item;
          }
          if (item.fieldCode == 'uploadFile') {
            uploadFile = item;
          }
        });
        if (description) {
          if (description.defaultMustFlag == 0) {
            this.descriptionFlag = false;
          } else {
            this.descriptionFlag = true;
          }
        }
        if (uploadFile) {
          if (uploadFile.defaultMustFlag == 0) {
            this.uploadFileFlag = false;
          } else {
            this.uploadFileFlag = true;
          }
        }
      });
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.dialogShow = false;
        })
        .catch(() => {});
    },
    // 打开完成表单
    openDialog(data) {
      let orderRow = data.orderRow;
      this.moduleType = orderRow.moduleType;
      console.log('333');
      this.getFieldDetail(orderRow.projectId, orderRow.moduleType, 8);
      console.log('openDialog(data)======>', data);
      this.dialogShow = true;
      this.tool.clearObject(this.form);
      this.orderId = data.orderId;
      this.form.orderId = data.orderId;
      // 获取备注模板
      getRemarkList({ orderId: data.orderId, actionType: data.actionType }).then((res) => {
        this.$refs.remarkModel.setRemarkList(res.data);
      });
    },

    closeDialog() {
      this.dialogShow = false;
    },

    formError(done) {
      done();
    },
    formSubmit1() {
      this.$refs.form.submit();
    },
    formSubmit(form, done) {
      if (this.descriptionFlag) {
        if (this.form.remark == '') {
          this.$message.error('请输入备注');
          done();
          return;
        }
      }
      if (this.uploadFileFlag) {
        if (this.form.attachList.length == 0) {
          this.$message.error('请上传附件');
          done();
          return;
        }
      }
      finish(form)
        .then((res) => {
          if (res.msg == '操作成功') {
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.dialogVisible = false;
            this.dialogShow = false;
          } else {
            this.$message.error(res.msg);
          }
          this.$emit('handleClose', function() {
            console.log('关闭历程表');
          });

          this.dialogShow = false;
          done();
        })
        .catch((err) => {
          done();
        });
    },
  },
};
</script>
